import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { RestoreTargetEnum } from 'mbs-ui-shared@models/cloud-restore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CloudRestorePermissionsRequestService {
  private http = inject(HttpClient);

  public sendPermissionsRequest(restoreType: RestoreTargetEnum, request: string): Observable<boolean> {
    return this.http.post<boolean>('/Admin/Shared/SendRequestForVMRestore', {
      request,
      restoreType
    });
  }
}
